export const aboutComparisonFr = {
  'about.problem.requires': 'Exige :',
  'about.problem.onlyfans.body': 'Un créateur à 10 000 $/mois perd 24 000 $ par an en frais.',
  'about.problem.onlyfans.requires': 'Compte bancaire + KYC',
  'about.problem.throne.body': 'Plus conversion de devises. Plus délais de retrait. Limité à 10 pays.',
  'about.problem.throne.requires': 'Compte bancaire + KYC',
  'about.problem.linktree.body': 'Ou payez 40 $/mois pour 0 % de frais. Dans tous les cas, ils prennent votre argent.',
  'about.problem.linktree.requires': 'Compte bancaire + processeur de paiement',
  'about.problem.kickstarter.body': 'Plus 5 000-25 000 $ de frais de livraison. Financement tout ou rien.',
  'about.problem.kickstarter.requires': 'Compte bancaire + KYC + livraison',
  'about.problem.indiegogo.body': '5 % retenus jusqu\'à la livraison. Délais de paiement de 14 jours. Flexible mais coûteux.',
  'about.problem.indiegogo.requires': 'Compte bancaire + KYC + livraison',
  'about.problem.katoa.body': 'Pas de frais. Pas de délais. Gardez 100 % jusqu’au 31 décembre 2026.',
  'about.problem.katoa.requires': 'Pas de compte bancaire. Pas de KYC.',
  'about.problem.avgLoss': 'Le créateur moyen perd',
  'about.problem.avgLossAmount': '12 000-24 000 $/an',
  'about.problem.allRequire': 'Les 5 plateformes exigent :',
  'about.problem.bankAccount': 'Compte bancaire',
  'about.problem.kyc': 'Vérification KYC',
  'about.problem.processors': 'Processeurs de paiement',
  'about.problem.geoLimits': 'Limites géographiques',
  'about.problem.katoaRequires': 'KATOA exige : RIEN',
  'about.problem.katoaWallet': 'Juste un portefeuille Bitcoin Lightning. C\'est tout.',
  'about.solution.title': 'Notre solution : Bitcoin + décentralisation',
  'about.solution.subtitle': 'Nous avons construit KATOA sur une technologie qui rend les frais de plateforme impossibles.',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': 'Le Lightning Network de Bitcoin permet des transactions rapides et à faible coût dans le monde entier dès que la réception Lightning sera en ligne (Roadmap : en cours). Pas de processeur qui prend une part. Pas de délais de 7 jours. Pas de restrictions géographiques.',
  'about.solution.lightning.item1': 'Règlements en moins d\'une seconde',
  'about.solution.lightning.item2': 'Fonctionne dans plus de 195 pays',
  'about.solution.lightning.item3': 'Micropaiements jusqu\'aux satoshis',
  'about.solution.lightning.item4': 'Pas de compte bancaire requis',
  'about.solution.nostr.title': 'Protocole Nostr',
  'about.solution.nostr.body': 'Un protocole social décentralisé qui rend la censure impossible. Votre compte, vos données, vos règles. Aucune entreprise ne peut vous bannir ni exploiter vos informations.',
  'about.solution.nostr.item1': 'Pas de suspensions de compte (vous possédez vos clés)',
  'about.solution.nostr.item2': 'Messagerie chiffrée optionnelle (NIP-17)',
  'about.solution.nostr.item3': 'Preuves de paiement à connaissance nulle (feuille de route)',
  'about.solution.nostr.item4': 'Distribué sur des relais dans le monde entier',
  'about.solution.result.title': 'Le résultat : 0 % de frais jusqu’au 31 décembre 2026',
  'about.solution.result.body': 'Quand les paiements circulent de pair à pair sur Bitcoin, il n\'y a pas d\'intermédiaire pour extraire des frais. Ce n\'est pas un tarif promotionnel. C\'est le fonctionnement de la technologie.',
  'about.values.title': 'Ce que nous défendons',
  'about.values.creators.title': 'Les créateurs d\'abord',
  'about.values.creators.desc': 'Chaque décision priorise les revenus et la liberté des créateurs.',
  'about.values.privacy.title': 'Confidentialité toujours',
  'about.values.privacy.desc': 'Collecte minimale. Paiements sans garde. Vos clés restent les vôtres.',
  'about.values.global.title': 'Vraiment mondial',
  'about.values.global.desc': 'Pas de discrimination géographique. Bitcoin fonctionne partout, pour tous.',
  'about.values.censorship.title': 'Anti-censure',
  'about.values.censorship.desc': 'Décentralisé par conception. Aucune entreprise ne peut vous bannir ni contrôler votre contenu.',
  'about.competitors.title': 'Pourquoi tous les concurrents échouent',
  'about.competitors.subtitle': 'Ils partagent tous le même défaut : la dépendance aux systèmes bancaires traditionnels.',
  'about.competitors.onlyfans.title': 'OnlyFans : 20 % de taxe plateforme',
  'about.competitors.onlyfans.body': 'Un créateur à 10 000 $/mois perd 2 000 $ par mois (24 000 $/an). Plus risque de censure Mastercard/Visa. Plus suspensions sans recours.',
  'about.competitors.kickstarter.title': 'Kickstarter : cauchemar de livraison',
  'about.competitors.kickstarter.body': '5 % de plateforme + traitement (en général ~8–10 % au total), plus 5 000–25 000 $+ de livraison. Si l\'objectif n\'est pas atteint, vous recevez 0 $.',
  'about.competitors.indiegogo.title': 'Indiegogo : retenues cachées',
  'about.competitors.indiegogo.body': '8-15 % de frais totaux, dont 5 % retenus jusqu\'à la livraison. Le financement flexible semble bien jusqu\'à ce qu\'ils retiennent votre argent.',
  'about.competitors.linktree.title': 'Linktree : monétisation payante',
  'about.competitors.linktree.body': 'Niveau gratuit : 10 % de frais. Ou payez 40 $/mois (480 $/an) pour 0 %. Dans tous les cas, vous perdez de l\'argent pour une simple page.',
  'about.competitors.throne.title': 'Throne : le calcul du 0 %',
  'about.competitors.throne.body': 'Annonce « 0 % de frais » ; le total typique tourne autour de 10 %. Le vrai 0 % ne s\'applique qu\'à ~10 pays ; ailleurs, vous payez le reste.',
  'about.competitors.con.bankKyc': 'Exige compte bancaire + KYC',
  'about.competitors.con.payout7': 'Délais de paiement de 7 jours',
  'about.competitors.con.payout14': 'Délais de paiement de 14+ jours',
  'about.competitors.con.censorship': 'Censure des processeurs de paiement',
  'about.competitors.con.countries': 'Limité aux pays pris en charge',
  'about.competitors.con.fulfillment': 'Stress expédition/livraison',
  'about.competitors.con.oneTime': 'Financement unique seulement',
  'about.competitors.con.holdback': '5 % retenus jusqu\'à livraison',
  'about.competitors.con.fulfillmentReq': 'Livraison obligatoire',
  'about.competitors.con.processor': 'Exige processeur de paiement',
  'about.competitors.con.geoRestrict': 'Restrictions géographiques',
  'about.competitors.con.feesOrSub': '9-10 % de frais ou 480 $/an',
  'about.competitors.con.countries50': 'Limité à 50 pays',
  'about.competitors.con.withdraw7': 'Délais de retrait de 7 jours',
  'about.competitors.con.countries10': 'Limité à 10 pays pour 0 %',
  'about.competitors.con.conversion': 'Frais cachés de conversion de devises',
  'about.competitors.katoa.title': 'KATOA : la seule vraie alternative',
  'about.competitors.katoa.body': 'Les frais de réseau/routage Lightning sont payés par les supporters. Nous publierons tout changement avant la fin de cette période.',
  'about.competitors.katoa.fee': '0 % de frais de plateforme jusqu\'au 31 décembre 2026',
  'about.competitors.katoa.feeDesc': 'Pris en charge par Give A Bit et le soutien de la communauté',
  'about.competitors.katoa.payout': 'Paiements rapides (Roadmap)',
  'about.competitors.katoa.payoutDesc': 'Via Lightning — dès que la réception est disponible (Roadmap : en cours).',
  'about.competitors.katoa.bank': '✓ Pas de banque nécessaire',
  'about.competitors.katoa.bankDesc': 'Juste un portefeuille Lightning.',
  'about.competitors.katoa.global': '✓ Plus de 195 pays',
  'about.competitors.katoa.globalDesc': 'Fonctionne partout de la même façon.',
  'about.audience.title': 'Qui nous servons',
  'about.audience.subtitle': 'KATOA a été créé pour les créateurs que les plateformes traditionnelles ignorent.',
  'about.audience.unbanked.title': 'Les non bancarisés',
  'about.audience.unbanked.body': 'Créateurs en Argentine, Nigeria, Venezuela, Vietnam. Pays où Stripe et PayPal ne fonctionnent pas.',
  'about.audience.unbanked.stat': 'Plus de 195 pays pris en charge',
  'about.audience.privacy.title': 'Les soucieux de confidentialité',
  'about.audience.privacy.body': 'Créateurs qui refusent la surveillance. Qui veulent le chiffrement de bout en bout. Qui exigent la souveraineté des données.',
  'about.audience.privacy.stat': 'Données minimales, sans garde',
  'about.audience.ambitious.title': 'Les ambitieux',
  'about.audience.ambitious.body': 'Créateurs gagnant 10 000-100 000 $+ par mois, fatigués de perdre 10-20 % en frais.',
  'about.audience.ambitious.stat': 'Économisez 12 000-240 000 $ par an',
  'about.team.title': 'Conçu par des créateurs, pour des créateurs',
  'about.team.body1': 'Nous sommes une équipe de créateurs fatigués de perdre 10-20 % de nos revenus aux plateformes. Alors nous avons construit mieux.',
  'about.team.body2': 'Nous ne sommes pas financés par des VC. Nous ne répondons pas aux investisseurs exigeant la croissance à tout prix. Nous répondons aux créateurs. C\'est pourquoi nous ne facturerons jamais de frais.',
  'about.team.promise': 'Notre promesse',
  'about.team.promise1': 'Nous ne facturerons jamais de frais de plateforme',
  'about.team.promise2': 'Nous n\'exploiterons jamais vos données',
  'about.team.promise3': 'Nous ne bannirons jamais les créateurs pour du contenu légal',
  'about.team.promise4': 'Nous prioriserons toujours vos revenus avant les nôtres',
  'about.cta.title': 'Rejoignez le mouvement',
  'about.cta.subtitle': 'C\'est encore tôt. Rejoignez-nous et gardez 100 % — 0 % de frais de plateforme jusqu’au 31 décembre 2026.',
  'about.cta.highlight': 'Soyez le prochain.',
  'about.cta.start': 'Commencez à gagner 100 %',
  'about.cta.compare': 'Voir les chiffres',
  'about.cta.footer': 'Pas de frais. Pas de KYC. Pas de pièges. Juste vous gardant 100 %.',
  'comparison.badge': 'Comparaison honnête • Sans marketing',
  'comparison.earningsLabel': 'Vos revenus mensuels (USD)',
  'comparison.savingsYearly': 'Basé sur ${amount}/mois — soit ${yearly}/an de retour dans votre poche.',
  'comparison.savingsVs': 'vs OnlyFans (${onlyfans}) · Throne (${throne}) · Linktree (${linktree})',
  'comparison.adjustCalc': 'Ajuster dans le calculateur ↓',
  'comparison.breakdown.title': 'Comparaison fonction par fonction',
  'comparison.table.feature': 'Fonctionnalité',
  'comparison.table.swipe': 'Glissez pour voir plus',
  'comparison.card.countries.title': 'Plus de 195 pays',
  'comparison.card.countries.body': 'Pas de compte bancaire ? Pas de problème. Bitcoin fonctionne partout, pour tous. Sans discrimination.',
  'comparison.card.countries.throne': 'Throne : ~10 pays avec 0 % de frais',
  'comparison.card.countries.katoa': 'KATOA : Tous les pays, 0 % jusqu’au 31 déc. 2026',
  'comparison.card.privacy.title': 'Vraie confidentialité',
  'comparison.card.privacy.body': 'Collecte minimale. Paiements sans garde. La messagerie chiffrée est optionnelle (NIP-17). Les preuves ZK sont sur la feuille de route.',
  'comparison.card.privacy.others': 'Autres : vos données sont leur produit',
  'comparison.card.privacy.katoa': 'KATOA : sans garde, données minimales',
  'comparison.card.instant.title': 'Règlement rapide (Roadmap)',
  'comparison.card.instant.body': 'Gardez 100 % de vos revenus. Développez-vous mondialement. Construisez sans taxes de plateforme.',
  'comparison.card.instant.others': 'Autres : attendez 7-14 jours pour les paiements',
  'comparison.card.instant.katoa': 'KATOA : Lightning Network instantané (avec réception Lightning — voir Roadmap)',
  'comparison.cta.title': 'Prêt à garder 100 % ?',
  'comparison.cta.subtitle': 'Rejoignez-nous dès maintenant. 0 % de frais de plateforme. Gardez ce que vos soutiens envoient — les frais Lightning existent encore.',
  'comparison.cta.start': 'Commencez à gagner 100 %',
  'comparison.cta.pricing': 'Voir les tarifs (spoiler : 0 $)',
  'comparison.cat.fees': 'Frais et coûts',
  'comparison.cat.banking': 'Exigences bancaires',
  'comparison.cat.global': 'Portée mondiale',
  'comparison.cat.payout': 'Vitesse de paiement',
  'comparison.cat.revenue': 'Modèles de revenus',
  'comparison.cat.privacy': 'Confidentialité et sécurité',
  'comparison.cat.payment': 'Fonctionnalités de paiement',
  'comparison.cat.control': 'Contrôle de la plateforme',
  'comparison.feat.platformFees': 'Frais de plateforme',
  'comparison.feat.paymentProcessing': 'Traitement des paiements',
  'comparison.feat.totalFee10k': 'Frais total sur 10 000 $',
  'comparison.feat.monthlySub': 'Abonnement mensuel',
  'comparison.feat.withdrawalFees': 'Frais de retrait',
  'comparison.feat.hiddenCosts': 'Coûts cachés',
  'comparison.feat.bankRequired': 'Compte bancaire requis',
  'comparison.feat.kyc': 'Vérification KYC/identité',
  'comparison.feat.noBanking': 'Fonctionne sans banque',
  'comparison.feat.processorDep': 'Dépendant du processeur de paiement',
  'comparison.feat.countries': 'Pays pris en charge',
  'comparison.feat.sanctioned': 'Bitcoin est mondial',
  'comparison.feat.instantIntl': 'Transferts internationaux rapides (Roadmap)',
  'comparison.feat.conversion': 'Frais de conversion de devises',
  'comparison.feat.payoutTime': 'Délai de paiement',
  'comparison.feat.instantSettlement': 'Règlement rapide (Roadmap)',
  'comparison.feat.holdback': 'Retenue de fonds',
  'comparison.feat.crowdfunding': 'Crowdfunding/projets',
  'comparison.feat.subscriptions': 'Abonnements (démo)',
  'comparison.feat.tips': 'Pourboires/dons',
  'comparison.feat.digital': 'Produits numériques',
  'comparison.feat.fulfillment': 'Livraison obligatoire',
  'comparison.feat.zk': 'Preuves à connaissance nulle (feuille de route)',
  'comparison.feat.encrypted': 'Messagerie chiffrée (NIP-17 optionnel)',
  'comparison.feat.decentralized': 'Infrastructure décentralisée',
  'comparison.feat.censorship': 'Résistant à la censure',
  'comparison.feat.micro': 'Support des micropaiements',
  'comparison.feat.bolt12': 'BOLT 12 récurrent (prévu)',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': 'Plusieurs sources de revenus',
  'comparison.feat.suspension': 'Risque de suspension de compte',
  'comparison.feat.contentCensor': 'Censure de contenu',
  'comparison.feat.ownData': 'Possédez vos données',
  'comparison.feat.ownKeys': 'Possédez vos clés',

  'comparison.cell.instant': 'Rapide',
  'comparison.cell.none': 'Aucun',
  'comparison.cell.varies': 'Variable',
  'comparison.cell.included': 'Inclus',
  'comparison.cell.limited': 'Limité',
  'comparison.cell.demo': 'Démo',
  'comparison.cell.planned': 'Prévu',
  'comparison.cell.roadmap': 'Feuille de route',

  'comparison.metaTitle': 'Comparaison des plateformes',
  'comparison.metaDesc': 'Comparez KATOA à OnlyFans, Throne, Kickstarter et d’autres. 0 % de frais de plateforme, règlement Lightning, pas de KYC pour commencer.',
} as const;